import { defineMessages } from 'react-intl';

export const saleBannerMessages = defineMessages({
  shopNow: { defaultMessage: 'Shop Now' },
  endsIn: { defaultMessage: 'Ends in:' },
});
